export default {
  middleware_url: "https://wip.lpsfrance.fluid-it.fr",
  cake_url: "https://wip.cake.lpsfrance.fluid-it.fr",
  isWavesoftEnabled: false,
  billingConforamaEnabled: false,
  isUrbantzEnabled: false,
  showLockBillingButton: true,
  googleMap: {
    api: "AIzaSyCNzBiL-zGLg5aVAXxIvvhXbe2NEquckUM",
  },
};
